import { utcToZonedTime } from 'date-fns-tz';

export interface AppAccessSettingsRow {
  id: number;
  is_enabled: boolean;
  /** Postgres time e.g. "08:00:00" or "09:30:00" */
  window_start: string;
  window_end: string;
  time_zone: string;
  updated_at: string;
}

/** Parse Postgres/SQL time string to minutes from midnight (0–1439). */
export function timeStringToMinutes(t: string): number {
  const parts = t.split(':').map((x) => parseInt(x, 10));
  const h = parts[0] ?? 0;
  const m = parts[1] ?? 0;
  return h * 60 + m;
}

/**
 * Half-open interval [start, end) in the configured IANA zone.
 * If end <= start, treats as overnight: allowed if time >= start OR time < end.
 */
export function isWithinAccessWindow(now: Date, row: AppAccessSettingsRow): boolean {
  if (!row.is_enabled) return true;

  const tz = row.time_zone?.trim() || 'Asia/Manila';
  let zoned: Date;
  try {
    zoned = utcToZonedTime(now, tz);
  } catch {
    zoned = utcToZonedTime(now, 'Asia/Manila');
  }

  const cur =
    zoned.getHours() * 60 + zoned.getMinutes() + zoned.getSeconds() / 60;
  const start = timeStringToMinutes(row.window_start);
  const end = timeStringToMinutes(row.window_end);

  if (end <= start) {
    return cur >= start || cur < end;
  }
  return cur >= start && cur < end;
}
